import React, { useState } from "react";
import "./_header.scss";
import { ReactComponent as LogoW } from "../../assets/img/logo_esteso_wh.svg";
import { ReactComponent as Logo } from "../../assets/img/logo-esteso.svg";
import { ReactComponent as Menu } from "../../assets/new-icons/menu.svg";
import { ReactComponent as Assistenza } from "../../assets/new-icons/assistenza.svg";
import { ReactComponent as Notifica } from "../../assets/new-icons/notifica.svg";
import { ReactComponent as Close } from "../../assets/new-icons/close.svg";
import HeaderNav from "../SideNav/HeaderNav";
import ListNav from "../SideNav/ListNav";
import { useSelector } from "react-redux";
import { Badge } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Notification from "./Notification/Notification";
import Assistence from "../SideNav/Assistence";
import { useNavigate } from "react-router-dom";
import SubHeader from "../SubHeader";

function NewHeader({ logo = "color", padding = "0 30px", iconsColor = '#697386', title = null, overlay = null, overlayTitle = 'Home', setOverlay }) {
  const navigate = useNavigate()
  const section = useSelector((user) => user.settings.section)
  const [seeMenu, setSeeMenu] = useState(false);
  const [seeNotifiche, setSeeNotifiche] = useState(false);
  const [seeAssistanceNav, setSeeAssistanceNav] = useState(false);
  const notificheEn = useSelector((user) => user.user.notifiche);
  const notificheGas = useSelector((user) => user?.gas?.notifiche);
  const notifiche = section ? notificheGas : notificheEn
  
  return (
    <>
      {seeMenu ? (
        <div className={`menuSidebar block`}>
          <div className="closeMenu" onClick={() => setSeeMenu(!seeMenu)}>
            <Close fill="#fff" />
          </div>
          <HeaderNav />
          <SubHeader inMenu={true}/>
          <ListNav seeNav={seeMenu} setSeeMenu={setSeeMenu} />
        </div>
      ) : null}
      {seeNotifiche ? (
        <div className="notSidebar block">
          <div className="notSidebar-header">
            <div className="notSidebar-header-left">
              {/* icona  */}
              <Notifica />
              <p className="label">Avvisi</p>
            </div>
            <div className="notSidebar-header-right">
              <div
                className="closeMenu"
                onClick={() => setSeeNotifiche(!seeNotifiche)}
              >
                <Close fill="#697386" />
              </div>
            </div>
          </div>
          <Notification />
        </div>
      ) : null}
      {seeAssistanceNav ? (
        <div className="assistenceSidebar block">
          <div className="assistenceSidebar-header">
            <div className="assistenceSidebar-header-left">
              {/* icona  */}
              <Notifica />
              <p className="label">Assistenza</p>
            </div>
            <div className="assistenceSidebar-header-right">
              <div
                className="closeMenu"
                onClick={() => setSeeAssistanceNav(!seeAssistanceNav)}
              >
                <Close fill="#697386" />
              </div>
            </div>
          </div>
          <Assistence />
          <div className="emptyBox" style={{height: '100px'}}></div>

        </div>
      ) : null}
      <div
        className="header"
        style={padding === "no" ? null : { padding: padding }}
      >
        <div className="header-left">
          {logo === "white" && !title && !overlay ? <LogoW onClick={() => section ? navigate('/enrica/gas') : navigate('/enrica')}/> : logo !== "whitee" && !title && !overlay ? <Logo onClick={() => navigate('/enrica')}/> : title && !overlay ? (
              <p className="logoTitle">{title}</p>
          ) : (
            <div className="overlay" onClick={() => setOverlay(!overlay)}>
              <ArrowBackIcon />
              <p className="logoTitle">{overlayTitle}</p>
            </div>
          )}
        </div>
        <div className="header-right">
          <div className="icon" onClick={() => setSeeNotifiche(!seeNotifiche)}>
            {notifiche[0] && notifiche[0].length > 0 ? (
              <Badge
                color="secondary"
                style={{ width: "20px", height: "20px" }}
                badgeContent={notifiche && notifiche[0].length}
              >
                <Notifica fill={iconsColor === 'white' ? `#fff` : iconsColor } />
              </Badge>
            ) : notifiche[1] && notifiche[1].length > 0 ? (
              <Badge
                color="secondary"
                style={{ width: "20px", height: "20px" }}
                badgeContent={notifiche && notifiche[1].length}
              >
                <Notifica fill={iconsColor === 'white' ? `#fff` : iconsColor } />
              </Badge>
            ) : (
              <Notifica fill={iconsColor === 'white' ? `#fff` : iconsColor } />
            )}
          </div>
          <div className="icon" onClick={() => setSeeAssistanceNav(true)}>
            <Assistenza fill={iconsColor === 'white' ? `#fff` : iconsColor } />
          </div>
          <div className="icon" onClick={() => setSeeMenu(!seeMenu)}>
            <Menu fill={iconsColor === 'white' ? `#fff` : iconsColor } />
          </div>
        </div>
      </div>
    </>
  );
}

export default NewHeader;
